import { useCreateUserCalendar } from 'src/hooks/useCreateUserCalendar'
import { OnboardingStep } from '../../OnboardingStep/OnboardingStep'
import { getStepStatus } from '../utils'
import { toaster } from 'src/utils/toaster'
import { downloadCalendarModalAtom } from 'src/atoms/modals/downloadCalendarModal.atom'
import { useSetAtom } from 'jotai'
import { ReactComponent as HelpIcon } from 'src/assets/svg/help.svg'
import { connectCalendarHelpModalAtom } from 'src/atoms/modals/connectCalendarHelpModal.atom'

import './CalendarStep.scss'

interface CalendarStepProps {
  readonly completed: boolean
  readonly enabled: boolean
}

export function CalendarStep({
  completed,
  enabled
}: Readonly<CalendarStepProps>) {
  const setDownloadCalendarModal = useSetAtom(downloadCalendarModalAtom)
  const setConnectCalendarHelpModal = useSetAtom(connectCalendarHelpModalAtom)

  const { createUserCalendar } = useCreateUserCalendar({
    onError,
    onCompleted
  })

  function handleCalendarSync() {
    createUserCalendar()
  }

  function onError() {
    toaster.error(`We couldn't connect your calendar. Please try again.`)
  }

  function onCompleted() {
    setDownloadCalendarModal({
      isOpen: true
    })
  }

  function handleHelpClick(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation()

    setConnectCalendarHelpModal({
      isOpen: true
    })
  }

  const status = getStepStatus(completed, enabled)

  return (
    <OnboardingStep
      className="calendar-step"
      title="Connect Your Calendar"
      description="Stay informed about your upcoming deliveries, order deadlines, and important subscription dates."
      status={status}
      icon="calendar"
      action={{
        label: 'Connect Calendar',
        onClick: completed ? onCompleted : handleCalendarSync
      }}>
      {completed && (
        <button
          className="calendar-step__help-container"
          onClick={handleHelpClick}>
          <HelpIcon width={16} />
          Trouble connecting your calendar?
        </button>
      )}
    </OnboardingStep>
  )
}
